module.exports = __webpack_public_path__ + "static/img/GlassesMan-1.7abb6223.png";